export const MIN_AGE = 18;
export const MAX_AGE = 100;
